var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component/lib';
import RootType from "../store/mutation-types";
import LoginService from "../../src/api/LoginService";
import CommonService from "../../src/api/CommonService";
import { CachePocily } from "../common/Cache";
import { ECache } from '../enum/ECache';
import CACHE_KEY from '../constant/cacheKey';
import Password from "./account/Dialog.vue";
import Register from "./Register.vue";
import RegisterResubmit from "./RegisterResubmit.vue";
import PasswordSetting from "../components/login/PasswordSetting.vue";
import RegexStr from "../common/RegexStr";
import { UrlHelper } from "../helper/UrlWrapper";
import { ESendCodeType } from "../enum/ESendCodeType";
import NoticeAfterLogin from "../components/login/NoticeAfterLogin";
import GlobalVue from "../globalVue";
import MyService from "./service/MyService.vue";
import GoodList from "./good/List.vue";
import { mapActions } from "vuex";
import { EServiceStatus } from "../enum/EStatus";
import AuthMixin from "../common/components/AuthMixin";
import WechatLogin from '../components/login/WechatLogin';
var phoneRegex = new RegExp(RegexStr.mobile);
var checkNoRegex = /\d{6}/;
var checkMsg = "发送验证码";
var serviceStatus = EServiceStatus;
var EShowType;
(function (EShowType) {
    EShowType[EShowType["No"] = 1] = "No";
    EShowType[EShowType["Pwd"] = 2] = "Pwd";
})(EShowType || (EShowType = {}));
var Login = (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = CachePocily.getInstance(ECache.LocCache);
        _this.showType = EShowType.Pwd;
        _this.checkMsg = checkMsg;
        _this.isLoginByWechat = false;
        _this.loginForm = {
            phone: "",
            password: "",
            checkNo: "",
            isRem: true,
            token: "",
            info_complete: 0,
            nickname: '',
            supplier_id: "",
        };
        _this.bannerImgs = [];
        _this.bannerImgsDefault = [{
                url: "../../static/image/banner_two.png"
            }, {
                url: "../../static/image/banner_one.png"
            }];
        return _this;
    }
    Login.prototype.created = function () {
        this.service = LoginService.getInstance();
        this.commonService = CommonService.getInstance();
        GlobalVue.$emit("closeDialog");
    };
    Login.prototype.checkLogin = function () {
        var msg = "";
        if (!phoneRegex.test(this.loginForm.phone)) {
            msg = "手机号格式不正确";
        }
        else if (this.showType === EShowType.Pwd && !this.loginForm.password) {
            msg = "密码不能为空";
        }
        else if (this.showType === EShowType.No && !checkNoRegex.test(this.loginForm.checkNo)) {
            msg = "验证码必须为6位数字";
        }
        return {
            success: !msg,
            msg: msg
        };
    };
    Login.prototype.setPassword = function () {
        var instance = this.$dialog(Password, {
            data: {
                isChangePwd: false
            }
        }, {
            title: "忘记密码",
            width: 600,
            height: 350
        }).instance;
    };
    Login.prototype.wechatRegister = function (data) {
        var _a = data.isResubmit
            ? [RegisterResubmit, { registerdata: data }, '修改注册信息']
            : [Register, {
                    unionid: data.unionid,
                    openid: data.openid,
                    phone: data.phone
                }, '账号注册'], RegisterComponent = _a[0], setData = _a[1], title = _a[2];
        var instance = this.$dialog(RegisterComponent, {
            data: setData
        }, {
            title: "账号注册",
            width: 600,
            height: 580,
        }).instance;
    };
    Login.prototype.register = function (registercode) {
        var instance = this.$dialog(Register, {
            data: {
                registercode: (registercode instanceof Event) ? '' : registercode || ""
            }
        }, {
            title: "账号注册",
            width: 600,
            height: 580,
        }).instance;
    };
    Login.prototype.registerResubmit = function (data) {
        var instance = this.$dialog(RegisterResubmit, {
            data: {
                registerdata: data
            }
        }, {
            title: "修改注册信息",
            width: 600,
            height: 580,
        }).instance;
    };
    Login.prototype.filterPhone = function () {
        this.loginForm.phone = this.loginForm.phone.replace(/[^\d-]/g, '');
        if (this.loginForm.phone.length > 11) {
            this.loginForm.phone = this.loginForm.phone.substring(0, 11);
        }
    };
    Login.prototype.filterCode = function () {
        this.loginForm.checkNo = this.loginForm.checkNo.replace(/[^0-9]/g, '');
        if (this.loginForm.checkNo.length > 6) {
            this.loginForm.checkNo = this.loginForm.checkNo.substring(0, 6);
        }
    };
    Login.prototype.filterPassword = function () {
        this.loginForm.password = this.loginForm.password.replace(/\s/g, '');
    };
    Login.prototype.phoneLogin = function () {
        var _this = this;
        var result = this.checkLogin();
        if (!result.success) {
            this.$message.error(result.msg);
            return;
        }
        this.clearFlag();
        this.service.loginByCode({ phone: this.loginForm.phone, smscode: this.loginForm.checkNo }).then(function (res) {
            res = res.data;
            _this.loginForm.token = res.data.token;
            _this.loginForm.nickname = res.data.nickname;
            _this.loginForm.supplier_id = res.data.supplier_id;
            _this.loginForm.info_complete = res.data.info_complete;
            _this.loginForm.is_bind_official_account = res.data.is_bind_official_account;
            _this.loginForm.account_mobile = res.data.account_mobile;
            _this.loginForm.account_name = res.data.account_name;
            _this.cache.save(CACHE_KEY.LOGIN, {
                ctime: new Date().getTime(),
                userInfo: JSON.stringify(_this.loginForm)
            });
            _this.$store.commit(RootType.UPDATE_LOGINMODEL, Object.assign({}, _this.loginForm));
            _this['getConfig'](_this.loginForm.supplier_id);
            _this.getBusinessConfig();
            _this['getOpenedCode']();
            _this['getOpenedEdiStatus']();
            if (res.data.is_first) {
                var instance = _this.$dialog(PasswordSetting, {
                    data: {
                        isChangePwd: true
                    }
                }, {
                    title: "设置密码",
                    width: 300,
                    height: 330,
                    closeBtn: false
                }).instance;
                instance.$on("setPassword:ok", function () {
                    _this.$message.success('设置成功！');
                    _this.$router.replace({
                        name: "Home"
                    });
                });
            }
            else {
                _this.$router.push('/home');
                _this.showNoticeDialog();
            }
        }, function (error) {
            _this.$message.error(error.message);
        });
    };
    Login.prototype.handleLogin = function (data) {
        console.log('------handleLogin', data);
        this.loginForm.token = data.token;
        this.loginForm.nickname = data.nickname;
        this.loginForm.supplier_id = data.supplier_id;
        this.loginForm.info_complete = data.info_complete;
        this.loginForm.is_bind_official_account = data.is_bind_official_account;
        this.loginForm.phone = this.loginForm.account_mobile = data.account_mobile;
        this.loginForm.account_name = data.account_name;
        this.cache.save(CACHE_KEY.LOGIN, {
            ctime: new Date().getTime(),
            userInfo: JSON.stringify(this.loginForm)
        });
        this.$store.commit(RootType.UPDATE_LOGINMODEL, Object.assign({}, this.loginForm));
        this.$router.push('/home');
        this['getConfig'](this.loginForm.supplier_id);
        this['getOpenedCode']();
        this['getOpenedEdiStatus']();
        window._czc.push(["_trackEvent", 'PC登录', '密码登录', '登录成功']);
    };
    Login.prototype.pwdLogin = function () {
        var _this = this;
        var result = this.checkLogin();
        if (!result.success) {
            this.$message.error(result.msg);
            return;
        }
        this.service.loginByPwd({
            phone: this.loginForm.phone,
            password: this.loginForm.password
        }).then(function (res) {
            res = res.data;
            _this.getBusinessConfig();
            if (30009 == res.code) {
                _this.registerResubmit(res.data);
            }
            else {
                _this.handleLogin(res.data);
            }
        }, function (error) {
            _this.$message.error(error.message);
            window._czc.push(["_trackEvent", 'PC登录', '密码登录', '登录失败']);
        });
    };
    Login.prototype.showNoticeDialog = function () {
        var _this = this;
        var tips = [];
        this.service.getNotice({}).then(function (res) {
            if (res.data.data.length == 0)
                return;
            tips = res.data.data;
            _this.openTipsDialog(tips);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    Login.prototype.openTipsDialog = function (tips) {
        var _this = this;
        var instance = this.$dialog(NoticeAfterLogin, {
            data: {
                tips: tips
            }
        }, {
            title: "提示",
            width: 420,
            zIndex: 100000,
            closeBtn: true
        }).instance;
        instance.$on('openMyService', function (noticeData) {
            _this.updateHomeShow(false);
            GlobalVue.$emit("addTab", {
                component: MyService,
                title: "会员服务",
                name: "service",
                showExist: true,
                cprops: {
                    noticeData: noticeData
                },
                callback: function () {
                    console.log('打开了会员服务');
                }
            });
        });
        instance.$on('payMyService', function (noticeData) {
            _this.updateHomeShow(false);
            GlobalVue.$emit("addTab", {
                component: MyService,
                title: "会员服务",
                name: "service",
                showExist: true,
                cprops: {
                    statusFromNotice: serviceStatus.Opened,
                    noticeData: noticeData
                },
                callback: function () {
                    console.log('打开了会员服务');
                }
            });
        });
        instance.$on('logout', function () {
            _this.logout();
        });
        instance.$on('openAddGood', function () {
            _this.getAuth('8001').then(function (pageAuth) {
                _this.updateHomeShow(false);
                GlobalVue.$emit("addTab", {
                    component: GoodList,
                    title: "货品档案",
                    name: "addgood",
                    showExist: true,
                    callback: function () {
                        console.log('上传货品');
                    },
                    cprops: __assign({}, pageAuth.Response, { Root_PageAuth: pageAuth && pageAuth.Auth, root_PageAuth$$: pageAuth && pageAuth.Auth })
                });
            });
        });
    };
    Login.prototype.getCheckNo = function () {
        var _this = this;
        if (this.timeFlag) {
            return;
        }
        var num = 60;
        this.checkMsg = num + "s \u540E\u91CD\u8BD5";
        this.timeFlag = setInterval(function () {
            num--;
            if (num === 0) {
                _this.clearFlag();
            }
            else {
                _this.checkMsg = num + "s \u540E\u91CD\u8BD5";
            }
        }, 1000);
        this.commonService.sendCode({ phone: this.loginForm.phone, type: ESendCodeType.login }).then(function (res) {
            _this.$message.success('发送成功！');
        }, function (error) {
            _this.$message.error(error.message);
        });
    };
    Login.prototype.clearFlag = function () {
        clearInterval(this.timeFlag);
        this.timeFlag = 0;
        this.checkMsg = checkMsg;
    };
    Login.prototype.mounted = function () {
        var infor = this.cache.getData(CACHE_KEY.LOGIN);
        if (infor) {
            if (infor.userInfo) {
                this.loginForm = JSON.parse(infor.userInfo);
                this.$store.commit(RootType.UPDATE_LOGINMODEL, Object.assign({}, this.loginForm));
                this.$router.push('/home');
                this['getConfig'](this.loginForm.supplier_id);
                this['getOpenedCode']();
                this['getOpenedEdiStatus']();
            }
        }
        var registercode = UrlHelper.getQueryString(location.href, "registercode");
        if (registercode) {
            this.register(registercode);
        }
        this.getBannerImage();
    };
    Login.prototype.getBannerImage = function () {
        var _this = this;
        this.service.getBannerImage().then(function (res) {
            if (res.data.data.length) {
                _this.bannerImgs = res.data.data;
            }
            else {
                _this.bannerImgs = _this.bannerImgsDefault;
            }
        }).catch(function () {
            _this.bannerImgs = _this.bannerImgsDefault;
        });
    };
    Login.prototype.logout = function () {
        var _this = this;
        this.service.logout().then(function (res) {
            _this.cache.remove(CACHE_KEY.LOGIN);
            _this.$store.commit(RootType.UPDATE_LOGINMODEL, null);
            _this.$router.push({ path: '/' });
        }, function (error) {
            _this.$message.error(error.message);
        });
    };
    Login.prototype.clickBannerImg = function (item) {
        window._czc.push(['_trackEvent', item.title, '点击']);
        console.log(111, ['_trackEvent', item.title, '点击']);
        var landing_type = item.landing_type || 0;
        if (2 == landing_type) {
            console.log(222, item.id);
            this.$router.push('/managementLandingCustom?id=' + item.id);
        }
        else if (3 == landing_type) {
            console.log(333, item);
            location.href = item.landing_url || '';
        }
    };
    Login.prototype.getBusinessConfig = function () {
        var _this = this;
        this.service.getBusinessConfigs().then(function (response) {
            if (response.data && response.data.data) {
                _this.$store.commit(RootType.UPDATE_ALL_SETTING_SCALE, response.data.data);
            }
            else {
                _this.$store.commit(RootType.UPDATE_ALL_SETTING_SCALE, []);
            }
        }).catch(function (error) {
            _this.$store.commit(RootType.UPDATE_ALL_SETTING_SCALE, []);
        });
    };
    Login = __decorate([
        Component({
            components: {
                WechatLogin: WechatLogin
            },
            mixins: [AuthMixin],
            methods: __assign({}, mapActions(["updateHomeShow", "getAuth"]))
        })
    ], Login);
    return Login;
}(Vue));
export default Login;
